export const messages = {
  en: {
    appManage: {
      title: 'Application Information',
      appId: 'App ID',
      appName: 'App Name',
      whiteList: 'White List',
      blackList: 'Black List',
      operations: 'Operations',
      addApp: 'Add App',
      edit: 'Edit',
      delete: 'Delete'
    },
    addApp: {
      title: 'Add Application',
      appName: 'App Name',
      appNamePlaceholder: 'Required, please enter app name',
      appNameRequired: 'App name is required',
      appNameLength: 'App name must be between 2-50 characters',
      securityCode: 'Security Code',
      securityCodePlaceholder: 'Optional, please enter security code',
      securityCodeLength: 'Security code cannot exceed 64 characters',
      whiteList: 'White List',
      whiteListPlaceholder: 'Optional, please enter white list',
      whiteListLength: 'White list cannot exceed 200 characters',
      blackList: 'Black List',
      blackListPlaceholder: 'Optional, please enter black list',
      blackListLength: 'Black list cannot exceed 200 characters',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      remarkLength: 'Remark cannot exceed 200 characters',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Added successfully'
    },
    editApp: {
      title: 'Edit Application',
      appName: 'App Name',
      appNamePlaceholder: 'Required, please enter app name',
      appNameRequired: 'App name is required',
      appNameLength: 'App name must be between 2-50 characters',
      securityCode: 'Security Code',
      securityCodePlaceholder: 'Optional, please enter security code',
      securityCodeLength: 'Security code cannot exceed 64 characters',
      whiteList: 'White List',
      whiteListPlaceholder: 'Optional, please enter white list',
      whiteListLength: 'White list cannot exceed 200 characters',
      blackList: 'Black List',
      blackListPlaceholder: 'Optional, please enter black list',
      blackListLength: 'Black list cannot exceed 200 characters',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      remarkLength: 'Remark cannot exceed 200 characters',
      appIdRequired: 'App ID is required',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Updated successfully'
    },
    deleteApp: {
      title: 'Confirm Operation',
      confirmDelete: 'Are you sure to delete this application?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    appManage: {
      title: '应用信息',
      appId: '应用ID',
      appName: '应用名称',
      whiteList: '白名单',
      blackList: '黑名单',
      operations: '操作',
      addApp: '添加应用',
      edit: '修改',
      delete: '删除'
    },
    addApp: {
      title: '添加应用',
      appName: '应用名称',
      appNamePlaceholder: '必填，请填写应用名称',
      appNameRequired: '应用名称不能为空',
      appNameLength: '应用名称必须在2至50字符之间',
      securityCode: '秘钥',
      securityCodePlaceholder: '选填，请填写秘钥',
      securityCodeLength: '秘钥太长超过64位',
      whiteList: '白名单',
      whiteListPlaceholder: '选填，请填写白名单',
      whiteListLength: '白名单内容不能超过200',
      blackList: '黑名单',
      blackListPlaceholder: '选填，请填写黑名单',
      blackListLength: '黑名单内容不能超过200',
      remark: '备注',
      remarkPlaceholder: '选填，请填写备注',
      remarkLength: '备注内容不能超过200',
      cancel: '取消',
      save: '保存',
      saveSuccess: '添加成功'
    },
    editApp: {
      title: '修改应用',
      appName: '应用名称',
      appNamePlaceholder: '必填，请填写应用名称',
      appNameRequired: '应用名称不能为空',
      appNameLength: '应用名称必须在2至50字符之间',
      securityCode: '秘钥',
      securityCodePlaceholder: '选填，请填写秘钥',
      securityCodeLength: '秘钥太长超过64位',
      whiteList: '白名单',
      whiteListPlaceholder: '选填，请填写白名单',
      whiteListLength: '白名单内容不能超过200',
      blackList: '黑名单',
      blackListPlaceholder: '选填，请填写黑名单',
      blackListLength: '黑名单内容不能超过200',
      remark: '备注',
      remarkPlaceholder: '选填，请填写备注',
      remarkLength: '备注内容不能超过200',
      appIdRequired: '应用Id不能为空',
      cancel: '取消',
      save: '保存',
      saveSuccess: '修改成功'
    },
    deleteApp: {
      title: '请确认您的操作',
      confirmDelete: '确定删除应用?',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}